/** Format helpers pinned to America/Los_Angeles */

export const TZ = "America/Los_Angeles";

export function fmtTimePT(iso) {
  return new Date(iso).toLocaleTimeString("en-US", {
    timeZone: TZ, hour: "numeric", minute: "2-digit", hour12: true,
  }).replace(" ", "\u00A0"); // non-breaking space
}

export function fmtDatePT(iso, opts = { month: "short", day: "numeric" }) {
  return new Date(iso).toLocaleDateString("en-US", { timeZone: TZ, ...opts });
}

/** "Apr 1, 2026" — the unambiguous form. The grid used to show only weekday +
 *  time, which was fine while it listed nothing but upcoming events; once the
 *  Luma history became browsable, a card reading "WED · 10:00 AM" could be from
 *  any year. */
export function fmtFullDatePT(iso) {
  return new Date(iso).toLocaleDateString("en-US", {
    timeZone: TZ, month: "short", day: "numeric", year: "numeric",
  });
}

/** Four-digit year in PT — for deciding whether a card needs to show one. */
export function yearPT(iso) {
  return new Date(iso).toLocaleDateString("en-US", { timeZone: TZ, year: "numeric" });
}

export function fmtWeekdayPT(iso) {
  return new Date(iso).toLocaleDateString("en-US", { timeZone: TZ, weekday: "long" });
}

export function fmtRangePT(startIso, endIso) {
  const dateLine = new Date(startIso).toLocaleDateString("en-US", {
    timeZone: TZ, weekday: "long", month: "long", day: "numeric",
  });
  const start = fmtTimePT(startIso);
  const end = fmtTimePT(endIso);
  return { dateLine, timeRange: `${start} — ${end}`, tzLabel: "PT" };
}
